module.exports = __webpack_public_path__ + "img/coletivo_nascer-cadastro.b7de36ed.jpg";